import axios from 'axios'

import {
  API_URL
} from "@/globalVariables";

export const pipedriveApi = {
  async getCustomFields(token) {
    try {
      const response = await axios.get('https://api.pipedrive.com/v1/dealFields', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      return response.data.data
    } catch (error) {
      console.error('Erro ao buscar custom fields:', error)
      throw error
    }
  },

  async getDealCustomField(dealId, token) {
    try {
      const response = await axios.get(`https://api.pipedrive.com/v1/deals/${dealId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      return response.data.data
    } catch (error) {
      console.error('Erro ao buscar deal:', error)
      throw error
    }
  },

  async refreshToken(token) {
    try {
      const response = await axios.post(`https://br2ht4cf5a.execute-api.sa-east-1.amazonaws.com/dev/pipedrive/auth`, {
        grant_type: "refresh_token",
        refresh_token: token,
        client_id: process.env.VUE_APP_PIPEDRIVE_CLIENT_ID,
        client_secret: process.env.VUE_APP_PIPEDRIVE_CLIENT_SECRET
      })

      console.log("refreshToken", response);
      return response.data.data
    } catch (error) {
      console.error('Erro ao obter novo token:', error)
      throw error
    }
  },

  async getRealEstateOrderSummary(orderId) {
    try {
      const response = await axios.get(`${API_URL}/real-estate/summary/${orderId}/`, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar resumo da order:', error)
      throw error
    }
  }
}